export default {
  priv: 'pr_device',
  overviewTitle: 'Testen',
  detailTitle: 'Testen',
  deleteTitle: 'deze test',
  url: '/devices/tests',
  apiUrl: '/devicetests/',
  sortBy: ['desc'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'devicetests',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'desc',
    type: 'text'
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'desc',
      link: '/devices/tests/{id}',
      width: '90%'
    }
  ]
};
